import PricePhaseEnum from '../../../../../shared/price-phase-enum';
import { camelCase } from '../../../../../shared/string-manipulations';

const getLeaguePricingData = ({
  pricingData,
  isMember,
  registration,
  teamData,
  shouldSeePricesWithFees = false,
}) => {
  const {
    currentPhase,
    originalPriceWithFees,
    voloPassPriceWithFees,
    voloFitnessPriceWithFees,
    originalPrice: originalPriceWithoutFees,
    memberPrice: voloPassPriceWithoutFees,
    voloFitnessPrice: voloFitnessPriceWithoutFees,
  } = pricingData?.programPricingForRegistration?.pricingBreakdown || {};

  // these two data points are required for labels to generate properly
  if (!teamData || !pricingData) return { infoLabel: 'error' };

  const { phases } = registration || {};
  const { earlyBird, regular } = phases || {};

  const originalPrice = shouldSeePricesWithFees ? originalPriceWithFees : originalPriceWithoutFees;
  const voloPassPrice = shouldSeePricesWithFees ? voloPassPriceWithFees : voloPassPriceWithoutFees;
  const voloFitnessPrice = shouldSeePricesWithFees
    ? voloFitnessPriceWithFees
    : voloFitnessPriceWithoutFees;

  const earlyBirdIndividualPrice = shouldSeePricesWithFees
    ? earlyBird?.individualPriceWithFees
    : earlyBird?.individualPrice;
  const regularIndividualPrice = shouldSeePricesWithFees
    ? regular?.individualPriceWithFees
    : regular?.individualPrice;

  let userPrice = originalPrice || '';
  if (isMember && voloPassPrice != null) {
    userPrice = voloPassPrice;
  } else if (currentPhase === PricePhaseEnum.EARLY_BIRD) {
    userPrice = earlyBirdIndividualPrice;
  }

  let infoLabel = '';
  if (isMember && userPrice !== originalPrice) {
    infoLabel = 'Volo Pass Pricing';
  } else if (currentPhase === PricePhaseEnum.EARLY_BIRD) {
    infoLabel = 'Early Bird Pricing!';
  }

  let basePrice = '';
  if (isMember && userPrice !== originalPrice) {
    basePrice = originalPrice;
  } else if (currentPhase === PricePhaseEnum.EARLY_BIRD) {
    // Note: This shows a strikethrough during early bird phase
    basePrice = regularIndividualPrice;
  }

  const { currentLeagueTeamPricing } = teamData || {};
  const teamPrice = currentLeagueTeamPricing?.[camelCase(currentPhase)] || '';

  return {
    infoLabel,
    userPrice,
    basePrice,
    teamPrice,
    voloPassPrice,
    voloFitnessPrice,
  };
};

export default getLeaguePricingData;
